import { getTheme } from '@ane/ui-components/lib/Styling';
export const ENTITY_NAME = 'Data source';
export const PAGE_TITLES = {
    create: `Create a data source`,
    view: `View data source`,
    list: `Manage data sources`,
};
export var validateStatus;
(function (validateStatus) {
    validateStatus["ValidateSuccess"] = "ValidateSuccess";
    validateStatus["ValidateFailed"] = "ValidateFailed";
    validateStatus["Unknown"] = "Unknown";
})(validateStatus || (validateStatus = {}));
export var validateStatusFriendly;
(function (validateStatusFriendly) {
    validateStatusFriendly["ValidateSuccess"] = "Validation succeeded";
    validateStatusFriendly["ValidateFailed"] = "Validation failed";
    validateStatusFriendly["Unknown"] = "Validation in progress";
})(validateStatusFriendly || (validateStatusFriendly = {}));
export var DataSourceTypes;
(function (DataSourceTypes) {
    DataSourceTypes["Main"] = "Main";
    DataSourceTypes["Sample"] = "Sample";
})(DataSourceTypes || (DataSourceTypes = {}));
export const ValidationIcons = {
    [validateStatus.ValidateSuccess]: {
        iconName: 'CompletedSolid',
        color: getTheme().palette.green,
    },
    [validateStatus.ValidateFailed]: {
        iconName: 'Blocked2Solid',
        color: getTheme().palette.redDark,
    },
    [validateStatus.Unknown]: {
        iconName: 'SyncStatusSolid',
        color: getTheme().palette.yellow,
    },
};
export const DataLocationComponentConstants = {
    SPDoubleConfirmDialog: {
        confirmBtn: {
            label: 'Confirm',
            ariaLabel: 'Confirm',
        },
        cancelBtn: {
            label: 'Cancel',
            ariaLabel: 'Cancel',
        },
        title: 'Confirm change',
        subText: `Do you want to change the service principal name?`,
        getInfo: (spName) => `(You will not be able to revert back to ${spName}. Hit cancel if you are not the owner of the service principal)`,
    },
    AAStreamExpirationDateField: {
        name: 'AAStreamExpirationDate',
        label: 'AAStream Expiration Date',
        description: 'Please enter AAStream Expiration Date',
    },
    AAStreamLocationPrefixField: {
        name: 'AAStreamLocationPrefix',
        label: 'AAStream Storage Prefix',
        description: 'e.g., /shares/<VC name>/local/projects/FlashResultAAStream/',
        errorMsg: 'Please provide a relative path',
    },
};
export const SpecialColumnsComponentConstants = {
    FlightDoubleConfirmDialog: {
        confirmBtn: {
            label: 'Confirm',
            ariaLabel: 'Confirm',
        },
        cancelBtn: {
            label: 'Cancel',
            ariaLabel: 'Cancel',
        },
        title: 'Confirm change',
        subText: `Do you want to change the flight format?`,
    },
};
export const DataSourceTypeOptions = [
    {
        key: DataSourceTypes.Main,
        text: DataSourceTypes.Main,
    },
    {
        key: DataSourceTypes.Sample,
        text: DataSourceTypes.Sample,
    },
];

//# sourceMappingURL=DataSource.constants.js.map
